import { ICommonData } from '@vfit/shared/models';
import { useCheckout } from '../../../iBuyMobile.context';
import { useEffect, useState } from 'react';
import {
  API,
  CONSUMER_CMS_SHOPPING_CART,
  IAddonCMS,
  IAddonCommonsCMS,
  IAddonDetailsCMS,
  useCmsConfig,
} from '@vfit/consumer/data-access';
import { evaluateCommonLabels } from './addonCard.utils';
import { LoggerInstance, trackLink } from '@vfit/shared/data-access';
import { SkeletonLoader } from './components/skeletonLoader';
import { AddonCardView } from './components/addonCardView';
import { ID_FLOWS } from '../../checkout.constants';
import TaggingAddonCard from './addonCard.tagging';

export const AddonCard = ({ handleOnChangeEnableGoNext, handleGoNextSlide }: ICommonData) => {
  const { product, addons, addonState, isLoadingCart, setAddonState, setCurrentStepKey } =
    useCheckout();
  const [loadingId, setLoadingId] = useState('');
  const [startAddonFlow, setStartAddonFlow] = useState(false);
  const [addonListFiltered, setAddonListFiltered] = useState<IAddonDetailsCMS[]>([]);
  const {
    availableAddons,
    isLoadingUpdate,
    isLoadingPriceUpdate,
    isLoading: isLoadingGetAddons,
  } = addonState;
  const addonListCMS = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_ADDONS_MOBILE
  ) as IAddonCMS;

  const addonCommonLabels = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_ADDONS_COMMON_MOBILE
  ) as IAddonCommonsCMS;

  const { title, ctaLabel } = evaluateCommonLabels(addonCommonLabels);

  const addonIdList = Object.keys(addonListCMS).filter((addonCMSId) =>
    product?.addonList?.includes(addonCMSId)
  );
  const addonList = addonIdList.map((id) => ({
    cmsId: id,
    ...addonListCMS[id],
  }));

  const callSaveAddon = (addon: string) => {
    const mecId = addonListCMS[addon]?.addondetails?.id || '';
    trackLink(`aggiungi ${mecId}`, 'users', 'click', 'cart_add');
    setAddonState({
      ...addonState,
      addonCmsId: addon,
      addonMecId: mecId,
      callSaveAddon: true,
    });
    setLoadingId(addon);
  };

  const callRemoveAddon = (addonToRemove: string) => {
    const mecId = addonListCMS[addonToRemove]?.addondetails?.id || '';
    trackLink(`rimuovi ${mecId}`, 'users', 'click', 'cart_remove');
    setAddonState({
      ...addonState,
      addonCmsId: addonToRemove,
      addonMecId: mecId,
      callRemoveAddon: true,
    });
    setLoadingId(addonToRemove);
  };

  const goNext = () => {
    trackLink(ctaLabel);
    handleGoNextSlide?.({}, false);
  };

  useEffect(() => {
    setCurrentStepKey(ID_FLOWS.ADDON_CARD);
    setStartAddonFlow(true);
  }, []);

  useEffect(() => {
    if (startAddonFlow && !isLoadingCart) {
      setAddonState({
        ...addonState,
        callGetAddons: true,
      });
      setStartAddonFlow(false);
    }
  }, [startAddonFlow, isLoadingCart]);

  useEffect(() => {
    if (availableAddons.length > 0) {
      LoggerInstance.debug('available addons: ', availableAddons);
      setAddonListFiltered(
        addonList?.filter((addon) => availableAddons?.includes(addon.addondetails?.id || '0'))
      );
    }
  }, [availableAddons]);

  useEffect(() => {
    if (!isLoadingUpdate) {
      setLoadingId('');
    }
  }, [isLoadingUpdate]);

  useEffect(() => {
    handleOnChangeEnableGoNext?.(
      !(isLoadingUpdate || isLoadingGetAddons || isLoadingCart || isLoadingPriceUpdate)
    );
  }, [isLoadingUpdate, isLoadingGetAddons, isLoadingCart, isLoadingPriceUpdate]);

  return (
    <>
      <TaggingAddonCard addonIdList={addonIdList} />
      {(isLoadingCart || isLoadingGetAddons) && <SkeletonLoader />}
      {!isLoadingCart && !isLoadingGetAddons && (
        <AddonCardView
          title={title}
          ctaLabel={ctaLabel}
          addonList={addonListFiltered}
          addedAddons={addons}
          isLoadingUpdate={isLoadingUpdate}
          isLoadingCartUpdate={isLoadingPriceUpdate}
          loadingId={loadingId}
          saveAddon={callSaveAddon}
          removeAddon={callRemoveAddon}
          goNext={goNext}
        />
      )}
    </>
  );
};

